module.exports = __webpack_public_path__ + "static/Apercu-BoldItalic-db8d767ba4a2eda49de516ce5826e188.woff";